import { Badge, Button } from "@heroui/react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { Address } from "viem";
import { useAccount } from "wagmi";
import { acceptToken } from "../../actions/acceptToken";
import { useIsApproverQuery } from "../../queries/ethereum";
import { allTokensQueryKey } from "../../queries/tokenReg";

export function AcceptTokenButton() {
  const queryClient = useQueryClient();
  const { address } = useAccount();
  const { data: isApprover, isLoading } = useIsApproverQuery(address);

  if (isLoading) {
    return null;
  }

  if (!isApprover) {
    return null;
  }

  return (
    <Badge color="danger" size="sm" showOutline={false} content="APPROVER">
      <Button
        onPress={async () => {
          try {
            const tokenAddr = window.prompt("Enter token address");
            if (!tokenAddr) return;
            await acceptToken(tokenAddr as Address);
            // Invalidate the token list to pick up the status change
            await Promise.all([
              queryClient.invalidateQueries({ queryKey: allTokensQueryKey() }),
              queryClient.invalidateQueries({ queryKey: ["token-details", tokenAddr as Address] }),
            ]);
            toast.success("Token Accepted");
          } catch (error) {
            console.error("Failed to accept token:", error);
            const errorMessage = error instanceof Error ? error.message : String(error);
            toast.error(`Failed to accept token: ${errorMessage}`);
          }
        }}
      >
        Accept token
      </Button>
    </Badge>
  );
}
